module.exports = __webpack_public_path__ + "img/lens-150-minus-04.35556199.png";